import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const Target = styled.div`
    padding-top: 100px;
    width: 1px;
    height: 1px;
    display: block;

    ${device.mobile}{
        padding-top: 20px;
    }
`;


const SimbolTarget = ({id}) => {
    return (
        <Target id={id}/>
    );
};

export default SimbolTarget;
